exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul.active a {\n  color: blue;\n}\n", ""]);

// exports
